import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-policy-street-sme-banner',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './policy-street-sme-banner.component.html',
  styleUrl: './policy-street-sme-banner.component.scss'
})
export class PolicyStreetSmeBannerComponent {

}
